module.exports = __webpack_public_path__ + "img/HIM.3de3899d.png";